module.exports = __webpack_public_path__ + "7d6b64f464268c8fa837b5e95cb46036.svg";


//////////////////
// WEBPACK FOOTER
// ./images/notes-green.svg
// module id = 80
// module chunks = 0